import {BrowserRouter, Navigate, Route, Routes} from 'react-router-dom'
import Login from "./pages/login";
import SignUp from "./pages/signup";
import {useAtomValue} from "jotai";
import Layout from "./pages/layout";
import Modal from "./components/modal/Modal";
import {modalController} from "./store";
import {ThemeProvider} from "styled-components";
import {useAtomsDevtools} from "jotai-devtools";
import {light} from "./assets/theme";
import {GlobalStyles} from "./assets/GlobalStyles";
import AdminLogin from "./pages/login/AdminLogin";
import {NotFound} from "./pages/404";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import ApiGuide from "./pages/api_guide";
import ApiGuideTest from "./pages/api_guide/ApiTest";
import "../src/assets/DatePicker.css"

const AtomsDevtools = ({ children }) => {
  useAtomsDevtools('demo')
  return children
}

const AppDevtools = ({children}) => (
  process.env.NODE_ENV === 'development'
    ? <AtomsDevtools>{children}</AtomsDevtools>
    : children
)

function App() {
  const modal = useAtomValue(modalController)
  return (
    <div className="App">
      <AppDevtools>
        <ThemeProvider theme={light}>
          <GlobalStyles/>
          <BrowserRouter>
            <Routes>
              <Route path={'/login'} element={<Login match={'login'}/>}/>
              <Route path={'/adminLogin'} element={<AdminLogin match={'login'}/>}/>
              <Route path={'/findId'} element={<Login match={'findId'}/>}/>
              <Route path={'/findPassword'} element={<Login match={'findPassword'}/>}/>
              <Route path={'/api-guide'} element={<ApiGuide/>}/>
              <Route path={'/api-guide/test'} element={<ApiGuideTest/>}/>
              <Route path={'/board/apiGuide'} element={<Navigate to="/api-guide" replace/>}/>
              <Route path={'/board/apiTest'} element={<Navigate to="/api-guide/test" replace/>}/>
              <Route path={'/board'} element={<Navigate to="/board/dashboard" replace/>}/>
              <Route
                path={'/board/:id'}
                element={
                  <ProtectedRoute>
                    <Layout/>
                  </ProtectedRoute>
                }
              />
              <Route path={'/'} element={<Login match={'login'} />}/>
              <Route path={'/signup'} element={<SignUp/>}/>
              <Route path={"*"} element={<NotFound/>}/>
            </Routes>
            <Modal isShow={modal.isShow}></Modal>
          </BrowserRouter>
        </ThemeProvider>
      </AppDevtools>
    </div>
  );
}

export default App;
